<template>
  <div>
    <div class="form-group">
      <label>{{translate('ozne.kurumKurulus.searchOrganization')}}</label>
      <select-input
        :value="selectedValue"
        :autocomplete="true"
        :placeholder="translate('search')"
        :datasource="detsisUrl"
        @change="setValue"
        style="width: 250px"
      >
        <span>{{ selectedValue }}</span>
        <template v-slot:item="{ item }">
          {{ prepareDetsisDisplayName(item) }}
        </template>
      </select-input>
    </div>
    <div class="form-group">
      <label>{{translate('ozne.kurumKurulus.name')}}</label>
      <div class="inline" style="display: flex">
        <input @input="checkInput('Ad',$event)" v-model.trim="value.Ad" type="text" class="form-control" required />
      </div>
    </div>

    <div class="form-group">
      <label>{{translate('ozne.kurumKurulus.organizationIdentityCode')}}</label>
      <input
      @input="checkInput('KurumKimlikKod',$event)"
        v-model.trim="value.KurumKimlikKod"
        type="tel"
        class="form-control"
        required
      />
    </div>
    <div class="form-group">
      <label>{{translate('ozne.kurumKurulus.detsisNo')}}</label>
      <input
      @input="checkInput('DetsisNumber',$event)"
        v-model.trim="value.DetsisNumber"
        type="tel"
        class="form-control"
        required
      />
    </div>
    <!-- <div class="form-group">
            <label>Başbakanlık Yazışma Kodu</label>
            <input v-model="value.BasbakanlikYazismaKod" type="text" class="form-control" required />
        </div> -->
  </div>
</template>

<script>
import selectInput from "../SelectInput.vue";

export default {
  components: {
    selectInput,
  },
  props: ["value"],
  data() {
    return {
      findRemBySearch: false,
      IletisimBilgisi: {
        Telefon: "",
        Telefon2: "",
        EPosta: "",
        Faks: "",
        Web: "",
        Adres: "",
      },
      KurumKimlikKod: "",
      selectedValue: this.value.Adi,
    };
  },
  computed: {
    detsisUrl(){
            return window.settings.detsisApiUrl + "Detsis/filterByName";
        },
  },
  methods: {
    prepareDetsisDisplayName(item){
        var ustKurum = item.KurumHiyerarsik;
        var replaced = ustKurum.replace(item.Ad,'').trim();
        if(replaced.endsWith('>'))
            replaced = replaced.replace(new RegExp('>' + '$'), '').trim();
        if(replaced)
            replaced = ' ('+replaced+')';
        return item.Ad+ replaced;
    },
    setValue(val) {
      this.value.KurumKimlikKod = val.AnaKurumIdareKimlikKodu;
      this.value.DetsisNumber = val.DETSISNo;
      this.selectedValue = val.Ad;
      this.value.Ad = this.selectedValue;
      this.getDetsisContactInfo(val.DETSISNo).then((x) => {
        if(!x.data.IsError){

        this.value.IletisimBilgisi.Telefon = x.data.Data?.PhoneNumber;
        this.value.IletisimBilgisi.Telefon2 = x.data.Data?.SecondPhoneNumber;
        this.value.IletisimBilgisi.EPosta = x.data.Data?.Eposta;
        this.value.IletisimBilgisi.Faks = x.data.Data?.FaxNumber;
        this.value.IletisimBilgisi.Web = x.data.Data?.WebAddress;
        this.value.IletisimBilgisi.Adres = x.data.Data?.Address;
        } 
      this.$forceUpdate();
      })
      .catch(x => {
                console.log("Unvan listesi yüklenemedi:", x);
            });
    },
    findByUnitName() {
      this.findRemBySearch = true;
    },
    checkInput(value, event) {
            // Check for invalid characters
            if (/[<>]/.test(event.target.value)) {
                alert(this.translate('errors.invalidSymbols'))
                const editedText = ""
                this.$set(this.value, value, editedText)
            } else {
                this.$set(this.value, value, event.target.value)
            }
        },
  },
};
</script>
